import React from 'react';
import FileConverter from './FileConverter';

export default function ConvertFiles() {
  return (
    <div className="ConvertFiles scene">
      <div className="page">
        <FileConverter />
      </div>
    </div>
  );
}
